import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.invite');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-invite',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.fund.invite/view.scss */
:host {
  display: block;
  height: 100%;
}

table td,
table th {
  vertical-align: baseline;
}

.form-control {
  border-radius: 4px;
}

.btn-opt {
  margin: 4px;
  border-radius: 30px;
  height: auto;
  font: normal normal normal 16px Montserrat;
  padding: 12px 30px;
  border: 1px solid #72787F;
}
.btn-opt:hover {
  color: #FF5933;
  border: 1px solid #FF5933;
  background-color: #FFF2ED;
}
.btn-opt.active {
  background-color: #FF5933;
  color: #FFF;
  border: 1px solid #FF5933;
}`],
})
export class PortalLpsysadminWidgetFundInviteComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;
    @Input() mode: any = "invite";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(["admin", "super_admin"], "/");
        await this.loadFields();
        await this.loadKeywords();
        await this.load();
        await this.service.loading.hide();
    }

    public listloaded: boolean = false;
    public list: any = [];
    public status: string = 'active';
    public user_status: string = '승인';
    public total: number = 0;
    public count: number = 0;
    public allcheck: boolean = false;

    public show_send_message: any = null;
    public checked_user_id: any = [];

    public fieldList: string[] = [];
    public subFieldList: string[] = [];

    public keywords: string[] = [];
    public newKeyword: string = '';
    public keywordsDirty: boolean = false;

    public search: any = {
        page: 1,
        orderby: "name",
        direction: "ASC",
        text: "",
        field: "",
        sub_field: "",
    };

    public async loadFields() {
        let { code, data } = await wiz.call("fields");
        if (code == 200) {
            this.fieldList = data.fields || [];
            this.subFieldList = data.sub_fields || [];
        }
    }

    public async loadKeywords() {
        let { code, data } = await wiz.call("load_keywords", { fund_id: this.fund.id });
        if (code == 200) {
            this.keywords = data.keywords || [];
            this.keywordsDirty = false;
        }
        await this.service.render();
    }

    public async addKeyword() {
        let kw = this.newKeyword.trim();
        if (!kw) return;
        if (this.keywords.includes(kw)) {
            this.newKeyword = '';
            await this.service.render();
            return;
        }
        this.keywords.push(kw);
        this.newKeyword = '';
        this.keywordsDirty = true;
        await this.service.render();
    }

    public async removeKeyword(index: number) {
        this.keywords.splice(index, 1);
        this.keywordsDirty = false;
        await this.service.render();
        await this._saveKeywords();
    }

    private async _saveKeywords() {
        try {
            let { code } = await wiz.call("save_keywords", { fund_id: this.fund.id, keywords: JSON.stringify(this.keywords) });
            if (code != 200) {
                await this.alert("키워드 저장에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("키워드 저장 중 오류가 발생했습니다.");
        }
    }

    public async saveKeywords() {
        //await this.service.loading.show();
        try {
            let { code } = await wiz.call("save_keywords", { fund_id: this.fund.id, keywords: JSON.stringify(this.keywords) });
            if (code == 200) {
                this.keywordsDirty = false;
                await this.alert("키워드가 저장되었습니다.", "success");
            } else {
                await this.alert("키워드 저장에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("키워드 저장 중 오류가 발생했습니다.");
        }

        //await this.service.loading.hide();
        await this.service.render();
    }

    public async autoInviteBulk() {
        if (this.keywords.length === 0) {
            return await this.alert("등록된 키워드가 없습니다.");
        }
        if (this.keywordsDirty) {
            return await this.alert("키워드를 먼저 저장해주세요.");
        }
        await this.service.loading.show();
        try {
            let { code, data } = await wiz.call("auto_invite_preview", { fund_id: this.fund.id });
            if (code != 200) return await this.alert("미리보기 조회 중 오류가 발생했습니다.");

            let previewCount = data.count;
            if (previewCount === 0) {
                return await this.alert("추천인 키워드에 매칭되는 미초대 회원이 없습니다.", "success");
            }

            let res = await this.service.alert.show({
                title: '추천인 기준 일괄 초대',
                message: `키워드에 매칭되는 미초대 회원 ${previewCount}명을 일괄 초대하시겠습니까?`,
                cancel: '취소',
                actionBtn: 'success',
                action: '일괄 초대',
                status: 'success'
            });
            if (!res) return;

            let result = await wiz.call("auto_invite_bulk", { fund_id: this.fund.id });
            if (result.code == 200) {
                await this.alert(`${result.data.count}명이 초대되었습니다.`, "success");
                await this.load(this.search.page);
            } else {
                await this.alert("일괄 초대 중 오류가 발생했습니다.");
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async filterByField(value: string) {
        this.search.field = this.search.field === value ? '' : value;
        await this.load();
    }

    public async filterBySubField(value: string) {
        this.search.sub_field = this.search.sub_field === value ? '' : value;
        await this.load();
    }

    public pagination: any = {
        end: -1,
        start: -1,
    };

    public async alert(message: string, status: any = "error") {
        return await this.service.alert.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: "확인",
            status: status
        });
    }

    public async load(page: number = 1, status: any = null) {
        if (!status) status = this.status;
        this.listloaded = false;
        let { code, data } = await wiz.call("list", {
            id: this.fund.id,
            page: page,
            text: this.search.text,
            field: this.search.field,
            sub_field: this.search.sub_field,
            orderby: this.search.orderby,
            direction: this.search.direction,
            user_status: this.user_status,
            status: status
        });
        if (code != 200) return;
        let { rows, lastpage, total, count } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.search.page = page;
        this.list = rows.map(item => {
            return {
                ...item,
                selected: false
            };
        });
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.listloaded = true;
        this.status = status;
        this.total = total;
        this.count = count;
        await this.service.render();
    }

    public async pageMove(page: number) {
        await this.load(page);
    }

    public async changeRole(item: any) {
        if (item.check) {
            if (item.check.status == '참여') return await this.alert("참여중인 조합원은 열람권한을 변경할 수 없습니다.");
            if (item.check.status == '대기') return await this.alert("대기중인 조합원은 열람권한을 변경할 수 없습니다.");
        }

        if (this.mode == 'invite') {
            item.check = !item.check;
        } else {
            item.check = true;
        }

        let user = {
            email: item.email,
            fund_id: this.fund.id,
            check: item.check,
            invite: this.mode == 'invite'
        };
        const { code } = await wiz.call("update", user);
        if (code != 200) return alert("error");
        await this.load(this.search.page);
    }

    public activeClass(target: string, status: string) {
        if (target == status) {
            return "group flex gap-x-3 mr-2 rounded-full bg-zinc-600 px-3.5 py-2 text-sm font-semibold text-white hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ";
        }
        return "group flex gap-x-3 rounded-md mr-2 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-zinc-600";
    }

    public target_user: any = null;

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            this.show_send_message = null;
            this.checked_user_id = [];
            await this.service.render();
        }
    }

    public allCheck(e) {
        document.querySelectorAll("input[type='checkbox']").forEach(item => {
            if (item.classList.contains("ng-valid") && item.checked !== e.target.checked) {
                item.click();
            }
        });
    }

    public async changeSelectedRole(e: any) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].selected) {

                if (this.mode == 'invite') {
                    this.list[i].check = !this.list[i].check;
                } else {
                    this.list[i].check = true;
                }

                let user = {
                    email: this.list[i].email,
                    fund_id: this.fund.id,
                    check: this.list[i].check,
                    invite: this.mode == 'invite'
                };

                const { code } = await wiz.call("update", user);
                if (code != 200) return alert("error");
            }
        }

        await this.load(this.search.page);
    }

    public async onClickOrder(order: string = "name") {
        if (this.search.orderby === order) {
            this.search.direction = this.search.direction === "ASC" ? "DESC" : "ASC";
        } else {
            this.search.orderby = order;
            this.search.direction = "ASC";
        }

        console.log(this.search)

        await this.service.render(500);
        await this.load();
    }

    public async revokeAll() {
        let res = await this.service.alert.show({
            title: '',
            message: '참여중인 조합원을 제외한 모든 열람권한을 해제하시겠습니까?',
            cancel: '취소',
            actionBtn: 'error',
            action: '전체 해제',
            status: 'error'
        });
        if (!res) return;

        await this.service.loading.show();
        for (let i = 0; i < this.list.length; i++) {
            const item = this.list[i];
            if (!item.check) continue;
            if (item.check.status === '참여') continue;

            let user = {
                email: item.email,
                fund_id: this.fund.id,
                check: false,
                invite: this.mode == 'invite'
            };
            await wiz.call("update", user);
        }
        await this.service.loading.hide();
        await this.load(this.search.page);
    }

    public async onClickSendMessage() {
        console.log(this.list);
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].selected) {
                this.checked_user_id.push(this.list[i].id);
            }
        }

        console.log(this.checked_user_id);
        this.show_send_message = true;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundInviteComponent;